import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpEventType, HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from "@core/bootstrap/config.service";
import { TokenService } from '@core/authentication/token.service';
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})

export class UploadComponent implements OnInit {
  public progress: number;
  public loadingUpload: boolean;
  public message: string;
  public apiUrl: string;
  @ViewChild('file') myInputVariable: ElementRef;
  @Input() title = '';
  @Input() url = '';
  @Input() path = '';

  @Input() params = [];
  @Output() public onUploadFinished = new EventEmitter();
  constructor(private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private token: TokenService,
    private config: ConfigService) {
    var conf = this.config.getConfig();
    this.apiUrl = conf.apiBaseUrl;
  }
  ngOnInit() {
    this.url = this.url || 'upload/UploadImage';
    this.title = this.title || '';
    this.loadingUpload = false;
  }
  public uploadFile = (files) => {
    this.progress = 0;
    this.message = '';
    if (files.length === 0) {
      return;
    }
    this.loadingUpload = true;

    const formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let fileToUpload = <File>files[i];
      formData.append('file[]', fileToUpload, fileToUpload.name);
    }
    formData.append('path', this.path);
    if (this.params && this.params.length > 0) {
      
      for (let index = 0; index < this.params.length; index++) {
        const p = this.params[index];
        formData.append(p.key, p.value);
      }
      // // this.params.forEach(p => {
      // //   formData.append(p.key, p.value);
      // // });
    }
    try {
      this.http.post(`${this.apiUrl + this.url}`, formData, {
        headers: {
          'Authorization': `Bearer ${this.token.get().token}`
        },
        reportProgress: true,
        observe: 'events'
      })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);

            if (this.progress >= 100) {
              this.progress = 0;
            }
            this.cdr.detectChanges();
          }
          else if (event.type === HttpEventType.Response) {
            this.message = 'OK';

            this.loadingUpload = false;
            this.onUploadFinished.emit(event.body);
          }
          this.myInputVariable.nativeElement.value = '';
        }, error => {
          this.myInputVariable.nativeElement.value = '';

          this.loadingUpload = false;
        });
    } catch (error) {
      this.loadingUpload = false;
    }

  }
}